import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import { mediaDown } from "styles/media"

const Image = styled(Img)`
  width: 138px;
  position: absolute !important;
  left: 50px;
  top: 50px;

  ${mediaDown.small`
    width: 128px;
    top: 10px;
    left: 0px;
  `}
`

const Logo = () => {
  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp(
        filter: {
          fluid: { originalName: { in: ["logo-desk.png", "logo-mobile.png"] } }
        }
      ) {
        nodes {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const logoDesktop = allImageSharp.nodes.find(img =>
    img.fluid.src.includes("logo-desk")
  )
  const logoMobile = allImageSharp.nodes.find(img =>
    img.fluid.src.includes("logo-mobile")
  )

  return (
    <>
      <div className="hide-medium-down">
        <Image fluid={logoDesktop.fluid} />
      </div>
      <div className="hide-medium-up">
        <Image fluid={logoMobile.fluid} />
      </div>
    </>
  )
}
// <Image fluid={image.fluid} visible={index === activeIndex} />

export default Logo
